module.exports = __webpack_public_path__ + "img/corner-joint-right-external.82839704.svg";